<style scoped lang="scss">
.development-content-div {
    margin-bottom: 3rem !important;
    background: #f5f7fa;
    font-size: 1rem;
    min-height: 100vh;
    padding: 1rem;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.not-developer-div {
    padding: 1.5rem;
    width: fit-content;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    text-align: center;

    p {
        font-size: 1rem;
        color: #333;
        margin-bottom: 1.5rem;
    }

    .el-button {
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
        border-radius: 4px;
    }
}

.deveploer-content {
    padding: 1.5rem;
    margin: 1rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .plugin-selector {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        span {
            font-size: 0.9rem;
            color: #333;
            margin-right: 0.5rem;
        }

        .el-select {
            margin-left: 0.5rem;
            width: 200px;

            :deep(.el-input__inner) {
                border-radius: 4px;
                border: 1px solid #dcdfe6;
                padding: 0.5rem;
                font-size: 0.9rem;
            }
        }

        .el-button {
            margin-left: 0.5rem;
            padding: 0.5rem 1rem;
            border-radius: 4px;
        }
    }
}

.versionLog_table {
    width: 100%;
    margin-top: 1rem;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    :deep(.el-table__header) {
        th {
            background: #f5f7fa;
            color: #333;
            font-weight: 500;
            padding: 0.75rem;
            font-size: 0.9rem;
            border-bottom: 1px solid #ebeef5;
        }
    }

    :deep(.el-table__body) {
        td {
            padding: 0.75rem;
            border-bottom: 1px solid #ebeef5;
            font-size: 0.9rem;
            color: #333;
        }

        tr {
            &:hover {
                background: #f5f7fa;
            }

            &:nth-child(even) {
                background: #fafafa;
            }
        }
    }
}

.el-button {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 0.9rem;

    &.el-button--primary {
        background: #409eff;
        border: none;
        color: white;

        &:hover {
            background: #66b1ff;
        }
    }

    &.el-button--warning {
        background: #e6a23c;
        border: none;
        color: white;

        &:hover {
            background: #ebb563;
        }
    }
}

:deep(.el-dialog) {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .el-dialog__header {
        background: #f5f7fa;
        margin: 0;
        padding: 1rem;
        border-bottom: 1px solid #ebeef5;

        .el-dialog__title {
            color: #333;
            font-size: 1rem;
            font-weight: 500;
        }

        .el-dialog__headerbtn {
            .el-dialog__close {
                color: #909399;
                font-size: 1rem;
            }
        }
    }

    .el-dialog__body {
        padding: 1rem;
    }

    .el-dialog__footer {
        padding: 1rem;
        border-top: 1px solid #ebeef5;
    }
}

.pagination-div {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;

    :deep(.el-pagination) {

        .btn-prev,
        .btn-next {
            border-radius: 4px;
            padding: 0.5rem;
        }

        .el-pager li {
            border-radius: 4px;
            padding: 0.5rem;

            &.is-active {
                background: #409eff;
                color: white;
            }
        }
    }
}

.el-select-liu {
    width: 200px !important;
    margin-left: 0.5rem;

    :deep(.el-input__inner) {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        padding: 0.5rem;
        font-size: 0.9rem;
        height: 32px;
        line-height: 32px;

        &:hover,
        &:focus {
            border-color: #409eff;
        }
    }

    :deep(.el-input__suffix) {
        right: 5px;
    }

    :deep(.el-input__icon) {
        line-height: 32px;
    }
}

@media screen and (max-width: 768px) {
    .development-content-div {
        padding: 0.5rem;
    }

    .deveploer-content {
        padding: 1rem;
        margin: 0.5rem;

        .plugin-selector {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;

            .el-select {
                width: 100%;
                margin-left: 0;
            }

            .el-button {
                width: 100%;
                margin-left: 0;
            }
        }
    }

    .versionLog_table {

        :deep(.el-table__header) th,
        :deep(.el-table__body) td {
            padding: 0.5rem;
            font-size: 0.85rem;
        }
    }

    .el-dialog {
        width: 95% !important;
    }

    .el-select-liu {
        width: 100% !important;
        margin-left: 0;
        margin-top: 0.5rem;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;padding-left: 0;padding-right: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;height:100vh;">
                    <div class="development-content-div">
                        <div v-if="isDeveloper == 0" class="not-developer-praent">
                            <div class="not-developer-div">
                                <p style="font-size: 1rem;">您还不是开发者，暂时无法查看本页面喔~</p>
                                <div
                                    style="text-align: center; width: fit-content;margin: 3rem auto 0.5rem;font-size: 1rem;">
                                    <el-button type="primary" @click="goApiUrl">
                                        成为开发者
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="isDeveloper == 1" class="d-flex flex-column deveploer-content rounded shadow">
                            <div>
                                <div>
                                    <span style="margin-left: 1rem;margin-right: 1rem;color:#616161">请选择插件</span>
                                    <el-select class="el-select-liu" v-model="selectIncludesId" placeholder="请选择"
                                        @change="getVersion">
                                        <el-option label="全部" :value="-1"></el-option>
                                        <el-option v-for="item in includes_data" :key="item.id"
                                            :label="item.id + '---' + item.name" :value="item.id"></el-option>
                                    </el-select>
                                    <el-button type="warning" style="margin-left: 1rem;"
                                        @click="versionRelease.isShow = true">版本发布</el-button>
                                </div>
                                <el-table :data="versionLogList" class="versionLog_table">
                                    <el-table-column prop="includes_id" label="插件id" width="70" />
                                    <!-- <el-table-column prop="update_desc" label="更新步骤" align="center"/> -->
                                    <el-table-column prop="update_desc" label="更新步骤" width="200">
                                        <template v-slot="scope">
                                            <el-input style="width: fit-content;" autosize type="textarea"
                                                v-model="scope.row.update_desc"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="update_url" label="下载url" align="center">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.update_url"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="version_code" label="版本号" width="100">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.version_code"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="version_name" label="版本名称" width="100">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.version_name"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="version_desc" label="版本介绍" width="200">
                                        <template v-slot="scope">
                                            <el-input type="textarea" style="width: fit-content;" autosize
                                                v-model="scope.row.version_desc"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center">
                                        <template v-slot="scope">
                                            <el-button type="primary" @click="saveVersionLog(scope.row)">保存</el-button>
                                            <el-button type="primary"
                                                @click="deleteVersionLog(scope.row.id)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination-div">
                                    <el-pagination class=" mt-4" background layout="prev, pager, next"
                                        :page-size="versionPage.pageSize" :total="versionPage.total"
                                        @current-change="currentChange" />
                                </div>
                            </div>

                        </div>
                        <el-dialog align-center v-model="versionRelease.isShow" title="版本发布" width="450"
                            class="el-dialog-liu">
                            <el-form>
                                <el-form-item label="插件" :label-width="formLabelWidth">
                                    <el-select class="el-select-liu" v-model="versionRelease.data.includes_id"
                                        placeholder="请选择">
                                        <el-option v-for="item in includes_data" :key="item.id"
                                            :label="item.id + '---' + item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="安装步骤" :label-width="formLabelWidth">
                                    <el-input type="textarea" :rows="3" autosize
                                        v-model="versionRelease.data.update_desc" autocomplete="off" />
                                </el-form-item>
                                <el-form-item label="更新介绍" :rows="3" :label-width="formLabelWidth">
                                    <el-input type="textarea" autosize v-model="versionRelease.data.version_desc"
                                        autocomplete="off" />
                                </el-form-item>
                                <el-form-item label="版本号" :label-width="formLabelWidth">
                                    <el-input v-model="versionRelease.data.version_code" autocomplete="off" />
                                </el-form-item>
                                <el-form-item label="版本名称" :label-width="formLabelWidth">
                                    <el-input v-model="versionRelease.data.version_name" autocomplete="off" />
                                </el-form-item>
                                <el-form-item label="下载链接" :label-width="formLabelWidth">
                                    <el-input v-model="versionRelease.data.update_url" autocomplete="off" />
                                </el-form-item>
                            </el-form>
                            <template #footer>
                                <div class="dialog-footer">
                                    <el-button @click="versionRelease.isShow = false">关闭</el-button>
                                    <el-button type="primary" @click="addVersionLog">
                                        新增
                                    </el-button>
                                </div>
                            </template>
                        </el-dialog>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox, getIncludesList } from "@/utils/publicMethods"
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { data } from 'jquery';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            versionLogList: [],
            versionPage: {
                currentPage: 1,
                pageSize: 5,
                total: 0
            },
            versionRelease: {
                isShow: false,
                data: {
                    includes_id: "",
                    version_code: "",
                    version_name: "",
                    version_desc: "",
                    update_desc: "",
                    update_url: ""
                }
            },
            includes_data: [],
            selectIncludesId: -1
        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        isNull(text) {
            return isNull(text);
        },
        currentChange(val) {
            this.versionPage.currentPage = val;
            this.getVersion();
        },
        getVersion() {
            console.log("getVersion");
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("includes_id", this.selectIncludesId + "")
            data.append("currentPage", this.versionPage.currentPage + "")
            data.append("pageSize", this.versionPage.pageSize + "")
            axios.post(baseURL + '/versionLog/list', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.versionLogList = res.data.data.list;
                        this.versionPage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getVersionByIncludes() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("currentPage", this.versionPage.currentPage + "")
            data.append("pageSize", this.versionPage.pageSize + "")
            data.append("includes_id", this.versionRelease.data.includes_id + "")
            axios.post(baseURL + '/versionLog/list', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.versionLogList = res.data.data.list;
                        this.versionPage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveVersionLog(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/versionLog/save', JSON.stringify(row), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg)
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error("失败")
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error("错误：" + err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludes() {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 5000, headers }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }, err => {
                    ElMessage.error(err)
                }
            )
        },
        deleteVersionLog(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/versionLog/delete?versionId=' + id, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg);
                        this.getVersion();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addVersionLog() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/versionLog/add', JSON.stringify(this.versionRelease.data), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        ElMessage.success(res.data.msg);
                        this.versionRelease.isShow = false;
                        this.getVersion();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        }
    },
    mounted() {
        this.getVersion()
        this.getIncludes()
    }
})
</script>
